import { Command } from '../../_base/actionBus/Command';

export class ForgotPassword extends Command {
    constructor(public email: string) {
        super();
    }
}
